import React from "react";
import { Container } from "reactstrap";
import "bootstrap/dist/css/bootstrap.css";
import "./AboutPage.css";

function AboutPage() {
  return (
    <div className="body">
      <Container>
        <div className="row mt-3 about-text">
          <div className="col-xs">
            <img src="./Author Portrait.jpg" className="portrait" />
          </div>
          <div className="col-lg">
          Hi all! I'm Quinn Thomas, an Epic and Adventure Fantasy author with a special interest in unique magic systems. I've been writing Fantasy novels for the last 15 years, totaling up to more than 2 million words written. Not all of them have been good, I'll admit, but I try to approach my writing experiences as a journey. With each story, I feel like I learn a little more and hone my craft ever-so-slightly more.
          <br />
          <br />
          I'm particularly fascinated by the cost of magic, and as you'll see from my recent short stories I've been moving away from gods as a source of magic in favor of mechanisms that allow for more exploration of what magic can really cost its wielders in tangible and intangible ways -- and what that says about our humanity. There will almost always be at least one of my short stories available for free, so check back often (or follow!) if there's one that catches your eye.
          </div>
        </div>
      </Container>
    </div>
  );
}
export default AboutPage;
